/**
 * Created by Pactera on 2017/4/14.
 * 选择日期
 */
import Routes from 'Routes';
import { saveOldLocation } from '../../modules/actions';
import { gspCollect } from '@csair/emp-helpers';
import { loadStatusCodeMsg } from 'enEXchange';
import { saveAiPramas } from '../endorsedApply/modules/actions';
export default store => ({
  path: Routes.ticket.child.selectDate.key,
  onEnter(nextState, replace, callback) {
    async function gointo() {
      loadStatusCodeMsg(['checkFlightDate']);
      window.sessionStorage.removeItem('pageButtonName');
      window.$sensors.sensors.track(
        'flight_ticket_refund_and_change_page_view',
        {
          page_name: '机票退改-选择变更日期页',
          channel_id: nextState.location.query.channel
            ? nextState.location.query.channel
            : '',
        }
      );
      const {
        App: { oldLocation },
        selectDate: { dates },
      } = store.getState();
      // history 的前进后退需避开日期页面
      if (
        oldLocation.pathname === Routes.ticket.child.ticketChange.path &&
        !oldLocation.query.changeKey &&
        !nextState.location.query.resetDateKey
      ) {
        // 航班选择页面 -> 乘机人和航段选择页面
        if (nextState.location.query.channel == 'AI') {
          if (
            (nextState.location.query.from &&
              nextState.location.query.from === 'assistant') ||
            window.sessionStorage.getItem('isAIComming')
          ) {
            if (
              /NHPAASWEBVIEW/i.test(navigator.userAgent) &&
              window.nh &&
              typeof window.nh.navigateBack === 'function'
            ) {
              window.nh.navigateBack(JSON.stringify({ url: '' }));
            } else {
              window.parent.postMessage(
                {
                  type: 'NH_AI_HALF_SCREEN_H5',
                  action: 'close',
                  payload: {},
                },
                '*'
              );
            }
            return false;
          } else {
            window.ft.miniProgram.navigateBack();
            return false;
          }
          return false;
        }
        window.history.go(-1);
      } else if (
        oldLocation.pathname === Routes.ticket.child.endorsedApply.path &&
        dates.length !== 0
      ) {
        // 乘机人和航段选择页面 -> 航班选择页面
        window.history.go(1);
      } else {
        callback();
      }
    }
    function messageEvent(event) {
      window.removeEventListener('message', messageEvent);
      // 必须验证来源！
      if (event.origin.indexOf('csair.com') < 0) return;
      // { userId: 123, token: 'abc' }
      window.sessionStorage.setItem(
        'nextStepParams',
        JSON.stringify(event.data)
      );
      window.localStorage.setItem(
        'routeType',
        event.data.isDomestic ? '国内' : '国际'
      );
      window.sessionStorage.setItem('isAIComming', true);
      store.dispatch(saveAiPramas(event.data));
      gointo();
    }
    if (
      nextState.location.query.channel == 'AI' &&
      !nextState.location.query.from
    ) {
      if (window.ft && window.ft.miniProgram) {
        window.ft.getStorage({
          key: 'nextStepParams',
          success: data => {
            window.sessionStorage.setItem(
              'nextStepParams',
              JSON.stringify(data.data)
            );
            window.localStorage.setItem(
              'routeType',
              data.data.isDomestic ? '国内' : '国际'
            );
            window.sessionStorage.setItem('isAICommingFT', true);
            store.dispatch(saveAiPramas(data.data));
          },
          fail: data => {},
          complete: data => {
            gointo();
          },
        });
      }
    } else if (
      nextState.location.query.channel == 'AI' &&
      nextState.location.query.from === 'assistant'
    ) {
      if (
        /NHPAASWEBVIEW/i.test(navigator.userAgent) &&
        window.nh &&
        typeof window.nh.getStartupParams === 'function'
      ) {
        const data =
          typeof window.nh.getStartupParams() === 'string'
            ? JSON.parse(window.nh.getStartupParams())
            : {};
        window.sessionStorage.setItem('nextStepParams', JSON.stringify(data));
        window.localStorage.setItem(
          'routeType',
          data.isDomestic ? '国内' : '国际'
        );
        window.sessionStorage.setItem('isAIComming', true);
        store.dispatch(saveAiPramas(data));
        gointo();
      } else {
        window.addEventListener('message', messageEvent);
      }
    } else {
      gointo();
    }
  },
  onLeave(prevState) {
    window.sessionStorage.removeItem('nextStepParams');
    store.dispatch(saveOldLocation(prevState.location));
  },
  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        const SelectDateContainer = require('./components/chooseDate/DateContainer')
          .default;
        cb(null, SelectDateContainer);
      },
      'selectDate'
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/routes/selectDate/index.js